import EntitiesView from 'Components/EntitiesView';
import { actions } from 'ducks/metadata';
import Show from 'Pages/Metadata/Show';
import React from 'react';
import { connect } from 'react-redux';
import columns from 'utils/columns/metadatas';

const MetadatasPage = props => {
    let { ...rest } = props;

    return (
        <EntitiesView
            columns={columns}
            showComponent={Show}
            {...rest}
        />
    );
};

const mapStateToProps = ({ metadatas: { allChecked, checked, ids, models, loading, searching, searchValue, sortBy, sortDirection } }) =>
    ({ allChecked, checked, ids, models, loading, searching, searchValue, sortBy, sortDirection });

const { changeSearch, changeSort, fetchAll, toggleAll, toggleOne } = actions;

const mapDispatchToProps = ({
    changeSearch,
    changeSort,
    fetchData: fetchAll,
    toggleAll,
    toggleOne: event => {
        event.stopPropagation();
        return toggleOne(event.target.name);
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(MetadatasPage);

